const clubFields = `
  id,
  content,
  name,
  short_description,
  club_leader,
  icon_border_color,
  description,
  created_at,
  configuration,
  mechanic_settings,
  leaders,
  social_links,
  advertised_project_tags,
  is_introductory_price_available,
  is_opened_to_subscriptions,
  image,
  mobile_image,
  dark_logo,
  light_logo,
  statistics
`;

export const projectPageFields = `
  id,
  content,
  mechanic,
  maturity,
  bonds_mechanic_settings,
  shares_mechanic_settings,
  goal,
  marketing_settings,
  scheduled_start_date,
  scheduled_end_date,
  started_at,
  finished_at,
  categories,
  tags,
  tax_exemption_mechanics,
  impact_score_in_percent,
  currency,
  total_amount_collected_in_cents,
  total_investors_count,
  fundraising_progress_min_goal,
  fundraising_progress_max_goal,
  status,
  project_agreement_and_security_contract,
  project_documents,
  is_referenced,
  my_ongoing_investment,
  club.fields(${clubFields}),
  risk_in_percent,
  transaction_fees,
  management_fees,
  operating_fees,
  is_trending
`;
